<template>
    <div class="mainLayout">
        <div class="lookup lookupDiv inner">
            <p class="innerTitle">{{lookupPromptText}}</p>
        
            <div class="horizFlex">
                <input ref="lookupText" id="lookupText"  class='lookupText' @keyup.enter='lookup' v-model="lookupTextValue" />
                <button class="lookupGo" v-on:click="lookup">{{lookupButtonText}}</button>
            </div>
            <div class="inactiveCheck">
                <input type="checkbox" id="jake" v-model="showInactiveElections">
                <label for="jake" class="rosterName" >{{showInactiveText}}</label>
            </div>
            <div class="wait" v-show="pleaseWait">
                <label for="">Please Wait...</label>
            </div>
            <div class="error">
                <label for="">{{errorMessage}}</label>
            </div>
            <div class="lookupResults scrollDivLookup" >
                <button :class="resultButtonclass(result.id)" v-for="result in lookupResults" :key="result.id" v-on:click="getElection(result.id)">
                    {{result.name}}
                </button>
            </div>
            <button class="addButtonElection" v-on:click="addNewElection()" :disabled="disableEdit" >{{addElectionButtonText}}</button>
        </div>
        <div v-if="isSelectedResult">
            <div class="main inner personCard" >
                <div class="personAddress">
                    <div class="horizFlex">
                        <p class="personName">{{selectedResult.name}}</p> 
                    </div>
                
                    <div class="horizFlex" v-if="!inEdit">
                        <ul class="textlist" >
                            <li class="locationtitle">{{electionDateText}}</li>
                            <li>{{displayDateStart}} - {{displayDateEnd}}</li>
                            
                            <hr/>
                            <li>{{electionPeopleText}}{{selectedResult.openTo}}</li>
                            <button class="linkButton linkButtonMedium" v-if="selectedResult.email!=null">{{ selectedResult.email }}</button>

                            <button class="linkButton linkButtonMedium" @click="ViewVoterList" >View Voter List</button>
                        </ul>
                    </div>

                    <!-- edit fields -->
                    <div class="vertFlex" v-if="inEdit">
                        
                        <div class="horizFlex">
                            <label for="" class="editLabel">Election Name</label>
                            <input class="editText" v-model="selectedResult.name"/>
                        </div>
                        <div class="horizFlex">
                            <label for="" class="editLabel">Start Date</label>
                            <input  class="editText" type="date" v-model="editDateStart"/>
                            <input  class="editText" type="time" v-model="timeStart"/>
                        </div>
                       <div class="horizFlex">
                            <label for="" class="editLabel">End Date</label>
                            <input  class="editText" type="date" v-model="editDateEnd"/>
                            <input  class="editText" type="time" v-model="timeEnd"/>
                        </div>
                       
                       <div class="horizFlex">
                            <label for="" class="editLabel">Open To</label>
                            <select name="" id="" class='editCombo' v-model="selectedResult.openTo" >
                                <option v-for="openTo in openToClubs" :key="openTo.Value" :value="openTo.Value">
                                    {{openTo.Name}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                
                <div class="personAction" v-if="!inEdit">
                    <button class="buttonPerson" v-on:click="editElection()" :disabled="disableEdit" >{{editButtonText}}</button>
                    <button class="duplicateButton" v-on:click="copyElection()" :disabled="disableEdit" >{{copyElectionButtonText}}</button>
                    
                    
                    <button class="emailButton" v-on:click="startEmailElection()" >Send Email</button>
                    
                    
                    <!-- <button class="buttonPerson" disabled=true>{{invitationButtonText}}</button> -->
                </div>
                <div class="personAction" v-if="inEdit">
                    <button class="buttonPerson" v-on:click="saveElection()">{{saveButtonText}}</button>
                    <button class="buttonPerson" v-on:click="cancelEditElection()">{{cancelButtonText}}</button>
                    <label for="">{{errorMessage}}</label>
                </div>
            </div>
            <div class="detail innerTransparent">
                <div class="itemTitleBar">
                    <div class="horizFlex itemTitle">
                        <p class="itemBarTitle itemTitle">Questions</p>
                        <p class="itemBarSubTitle">{{questionCountText}} {{selectedResult.questionCount}}</p>
                    </div>
                    <div class="inactiveCheck" >
                        <input type="checkbox" id="jake" v-model="showInactiveQuestions">
                        <label for="jake" class="rosterName">{{showInactiveText}}</label>
                    </div>
                    <div class="addbuttondiv">
                        <editquestion ref="addquestionbutton" isNew='true' @showinactive="updateIsActive()"  :electionId="selectedResult.id" :questionSetId="selectedResult.questionSetId" @refresh="refresh()" @save="saveElection()" :disabled="disableEdit"></editquestion>
                    </div>
                    <!-- <button class="addButton" v-on:click="addNewQuestion()" :disabled="disableEdit" >{{addQuestionButtonText}}</button> -->
                     
                </div>
                <div class="scrollDiv">
                    <div v-bind:class="questionClass(question.id)" v-for="question in filteredQuestions" :key="question.id" >
                        <div v-if="!questionInEdit(question.id)" >
                            <div>
                                <p class="innerTitle electionTitle">{{question.name}}</p>
                                <p class="questionDetail">{{question.questionDetails}}</p>
                                <img :src="getImage(question.questionDocument)"   class="image" v-if="question.questionDocument!=null" >
                                <div  v-for="option in question.options" :key="option.id" >
                                    <div class="horizFlex flexLeft">
                                        <p class="optionTitleLabel">{{option.optionText}}</p>
                                       
                                    </div>
                                    
                                    <!-- <p class="optionDetail" >before text <a href="http://www.schoolvision.net" target="_blank">link</a> after text</p> -->
                                    <p class="optionDetailLabel" >{{option.optionDetail}}</p>
                                     <img :src="getImage(option.optionImage)"   class="image_option" v-if="option.optionImage!=null" >
                                </div>    
                            </div>
                        </div>
                       
                        
                        <!-- actions -->
                        <div class="itemAction" v-if="!questionInEdit(question.id)">
                            <editquestion :inquestion="question" :electionId="selectedResult.id" @showinactive="updateIsActive()"  @refresh="refresh()" :disabled="disableEdit"></editquestion>
                            <!-- <button class="button" v-on:click="editQuestion(question.id)" :disabled="disableEdit" >{{editButtonText}}</button> -->
                        </div>
                       <!--  <div class="itemAction" v-if="questionInEdit(question.id)">
                            <button class="button" v-on:click="saveQuestion(question.id)">{{saveButtonText}}</button>
                            <button class="button" v-on:click="cancelEditQuestion(question.id)">{{cancelButtonText}}</button> -->
                            
                            
                            <!-- <button class="linkButton removeButton" v-on:click="removeQuestion(question.id)">{{removeQuestionButtonText}}</button> -->
                        <!-- </div>  -->
                    </div>   
                </div>
            </div>
        </div>

        <modal ref="emailModal">
            <template v-slot:header>
            <div class="horizFlex">
                <p class="innerTitle">Send Election Email</p>
            </div>
            
            </template>

            <template v-slot:body>
                <div class="center">
                    <div  class="sendEmailDiv">
                        <form ref="sendemailform">
                        <div class="horizFlex below5">
                            <input class="sendEmailLabel" type="radio" name="emailinvite" v-model="emailType" value="all" ref="allRadio" @change="useAllVoters"/>
                            <label class="sendEmailLabel">All Voters for this Election</label>
                        </div>
                        <div class="horizFlex">
                            <input class="sendEmailLabel" type="radio" name="emailinvite" v-model="emailType" value="email" ref="emailRadio" @change="useEmail"/>
                            <label class="sendEmailLabel">By Email</label>
                            <input  class="sendEmailField" type="email" v-model="emailForInvite" @focus="changedEmail()"/>
                        </div>
                        <div class="horizFlex">
                            <input class="sendEmailLabel" type="radio" name="emailinvite" v-model="emailType" value="badge" ref="badgeRadio" @change="useBadge">
                            <label class="sendEmailLabel">By Rec Card</label>
                            <input  class="sendEmailField"  v-model="badgeForInvite" @focus="changedBadge()"/>
                        </div>
                        <div class="sendEmailDiv">
                            <label class="message" v-if="sendEmailMessage!=''">{{sendEmailMessage}}</label>
                            <label class="messagepositive" v-if="sendEmailMessagePositive!=''">{{sendEmailMessagePositive}}</label>
                        </div>
                        <div class="sendEmailDiv">
                            <button class="emailButton" type="button" v-on:click="sendEmailElection()"  >Send</button>
                            <button class="emailButton" type="button" v-on:click="cancelEmailElection()"  >Close</button>
                        </div>
                        </form>
                        
                    </div>
                </div>
            
            </template>
            
         
        </modal>
        <modal ref="voterListModal" class="votermodal">
            <template v-slot:header>
            <div class="horizFlex">
                <p class="innerTitle">Voter List</p>
            </div>
            
            </template>

            <template v-slot:body>
                <div class="votelistdiv">
                    <ul>
                        <li v-for="p in voterList" :key="p.id" class="voterlistitem">{{p.name}}</li>
                    </ul>    
                </div>
                <div class="sendEmailDiv">
                    <button class="emailButton" v-on:click="$refs.voterListModal.closeModal()"  >Close</button>
                </div>
            </template>
            
      
        </modal>
    </div>
</template>

<script>
import {HTTP} from '../Repository'
import modal from './modal.vue'
import editquestion from './actions/EditQuestion.vue'
import tokenhelper from '../tokenhelper.js'
export default {
    mixins:[tokenhelper],
    props:{
        canEdit:{
            type:String,
            default:'false'
        },
    },
    components:{
        modal,
        editquestion
    },
    data(){
        return{
            pleaseWait:false,
            inEdit:false,
            showInactiveQuestions:false,
            isAutoSave:false,
            errorMessage:'',
            sendEmailMessage:'',
            sendEmailMessagePositive:'',

            imageBasePath:'',
            locationId:1,

            lookupTextValue:'',

            editDateStart:'',
            displayDateStart:'',
            timeStart:'',

     
            editDateEnd:'',
            timeEnd:'',
            displayDateEnd:'',

            showInactiveElections:false,
            lookupResults:{},
            roles:{},
            elections:{},
            selectedResult:{},
            isSelectedResult:false,

            lookupPromptText:'Lookup Election',
            lookupButtonText:'Go',
            editButtonText:'Edit',
            addQuestionButtonText:'+ Question',
            addElectionButtonText:'Add Election',
            copyElectionButtonText:'Duplicate',
            showInactiveText:'Show Inactive',
            questionCountText:'Questions:',
           
            saveButtonText:'Save',
            cancelButtonText:'Cancel',
            editDuesPaidText:'Dues Paid',
            isActiveText:'Is Active',
            electionDateText:'Election Open: ',
            electionPeopleText:'Open to: ',
            invitationButtonText:'Send Invitation',

            questionTitleText:'Question Title',
            questionDescriptionText:'Question Description',
            optionTitle:'Options',
            addOptionButtonText:'Add Option',
            optionNameText:'Option Title',
            optionDescriptionText:'Option Detail',
            selectImageButtonText:'To select a new image, 1. click Choose File and 2. Click Upload Image',
            removeOptionButtonText:'Remove Option',
            removeQuestionButtonText:'Remove Question',

            selectedFile:null,
            selectedFileURL:null,
            selectedFilePreview:null,

            openToClubs:{},
            isNewElection:false,
            newOptionQuestionID:-1,

            emailForInvite:'',
            badgeForInvite:'',
            inSendEmail:false,
            emailType:"all",
            voterList:[],

            //flags
            inAddOption:false,
            inUpload:false,
            questionforEdit:-1,
            optionForEdit:-1,
            inUploadOption:false,
        }
    },
    mounted(){
        this.getImageBasePath();
        this.getOpenToList();
    },
    computed:{
        
        disableEdit:function(){
            return this.canEdit=='false' || this.canEdit=='False'
        },
    	filteredQuestions(){
            if(this.showInactiveQuestions){
                return this.selectedResult.questions
            }else{
                let tempQuestion = this.selectedResult.questions
                if(tempQuestion!=undefined){
                    tempQuestion = tempQuestion.filter((item)=>{
                        return (item.isActive)
                    })
                }
                
                return tempQuestion
            } 
        }
    },
    methods:{
        AddTokenToAPI(){
            var token = this.getToken()   
            HTTP.defaults.headers.post['token']=token
        },
        refresh(){
            this.getElection(this.selectedResult.id)
        },
        resultButtonclass(id){
            if(this.selectedResult==undefined){
                return "resultButton"
            }else if(id==this.selectedResult.id){
                return "resultButton resultButtonSelected"
            }else{ return "resultButton"}
        },
        ViewVoterList(){
            this.pleaseWait=true;
            let req = {
                electionId:this.selectedResult.id,
            }
            this.AddTokenToAPI();
            HTTP.post('voterlist',req)
            .then(response=>{
                this.voterList =  response.data.PersonList
                this.$refs.voterListModal.openModal()
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e

            });
        },
        setType(){
            console.log('settype ')
            var i;
            for(i=0;i<this.openToClubs.length;i++){
                var object = this.openToClubs[i]
                if(object.Value==this.selectedResult.openTo){
                    this.selectedResult.ObjectTypeName=object.sType
                }
            }
            
        },
         getImageBasePath(){
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('electionimagepath')
            .then(response=>{
                this.imageBasePath = window.VUE_CONFIG_API + response.data.StringResponse
                console.log("got imagepath " + this.imageBasePath)
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e

            });
        },
        getOpenToList(){
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('electionopento')
            .then(response=>{
                this.openToClubs =  response.data.SurveyObjectList
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e

            });
        },
        getImage(imagePath){
            console.log(this.imageBasePath + imagePath)
            return this.imageBasePath + imagePath;
            //return require("../assets/" + imagePath)
        },
        lookup(){
             let req = {
                lookupText:this.lookupTextValue,
                includeInactive:this.showInactiveElections
            }
            this.AddTokenToAPI();
            HTTP.post('lookupelection',req)
            .then(response=>{
                this.lookupResults = response.data.ElectionList
                
            })
            .catch(e=>{
                return e
            });
            
        },
        addNewElection(){
            this.isNewElection=true;
            let newe={'id':'-1','locationId':this.locationId,'name':'New Election','isActive':true};
            

            console.log(newe)
            this.selectedResult=newe;
            var dt = new Date();
            this.selectedResult.dateStart = dt;
            var tomorrow = new Date();
            this.selectedResult.dateEnd= tomorrow.setDate(dt.getDate() + 1);
            this.splitDates();

            this.isSelectedResult=true;
            this.editElection();
        },
        startEmailElection(){
            this.inSendEmail=true
            this.emailForInvite=null;
            this.badgeForInvite=null;
            this.sendEmailMessage='';
            this.sendEmailMessagePositive='';
            this.emailType="all";
            this.$refs.emailModal.openModal()
            
        },
        cancelEmailElection(){
            this.inSendEmail=false
           this.$refs.emailModal.closeModal()
        },
        useAllVoters(){
            if(this.$refs.allRadio.checked){
                this.emailForInvite=null;
                this.badgeForInvite=null;
            }
        },
        useEmail(){
            if(this.$refs.emailRadio.checked){
                this.badgeForInvite=null;
            }
        },
        useBadge(){
            if(this.$refs.badgeRadio.checked){
                this.emailForInvite=null;
            }
        },
        changedEmail(){
            console.log("changedemail" + this.emailForInvite)
            
                this.emailType="email"
                this.badgeForInvite=null;
            
        },
        changedBadge(){
           
                this.emailType="badge"
                this.emailForInvite=null;
            
        },
        sendEmailElection(){
            if(this.$refs.sendemailform.checkValidity()==false){return}
            let req = {
                electionId:this.selectedResult.id,
                badgeNumber:this.badgeForInvite,
                emailAddress:this.emailForInvite,
                
            }
            console.log('b: ' + req)
            this.pleaseWait=true;
            this.sendEmailMessage='';
            this.sendEmailMessagePositive='';
            this.AddTokenToAPI();
            HTTP.post('electionemail',req)
            .then(response=>{
                console.log(response.data.Successful)
                if(response.data.Successful){
                    this.sendEmailMessagePositive= response.data.ResponseInteger +  " Email Invitation(s) Sent";
                }else{
                    this.sendEmailMessage="Email Error: " + response.data.RequestException.Message;
                }
                this.pleaseWait=false;
                
            })
            .catch(e=>{
                this.pleaseWait=false;
                console.log('election fail ' + e)
                return e
            });
        },
        copyElection(){
            
            let req = {
                election:this.selectedResult
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('copyelection',req)
            .then(response=>{

                if(response.data.success){
                    this.getElection(response.data.id)
                    this.editElection();
                }else{
                    this.errorMessage="API Error: " + response.data.RequestException.Message;
                }
                this.pleaseWait=false;
                
            })
            .catch(e=>{
                this.pleaseWait=false;
                console.log('election fail ' + e)
                return e
            });
        },
        
        addNewOption(questionID){
            if(questionID==-1){
                this.inAddOption=true
                this.questionforEdit=questionID
                this.saveQuestionOnly(questionID);
                console.log('no question yet')
                return
            }
            var question = this.getquestionByID(questionID)
            let newo={'id':'-1', 'optionText':'New Option','optionDetail':'','isValid':true};
            console.log(newo)
            console.log('qid in add ' + questionID)
            question.options.splice(0,0,newo);
            
        },
        getElection(electionID){
            this.isSelectedResult=true;
            
            let req = {
                electionId:electionID,
                personId:-1,
                locationId:this.locationId
            }
            this.AddTokenToAPI();
            HTTP.post('election',req)
            .then(response=>{
                console.log(response)
                if(response.data.Successful){
                    this.selectedResult = response.data.election
                    console.log("result " + this.selectedResult)


                    this.splitDates();

                    //if we are a new election we just saved it, now we have to add the question
                    if(this.isNewElection){
                        this.isNewElection=false
                        this.$refs.addquestionbutton.addNewQuestion(this.selectedResult.questionSetId);
                    }else if(this.inUpload || this.inAddOption || this.inUploadOption){
                        var questionID = this.questionforEdit//we stashed id
                         this.editQuestion(questionID)

                     if(this.inAddOption==true){
                         this.inAddOption=false
                         this.addNewOption(questionID) 
                         
                     }else if(this.inUpload==true){
                         this.inUpload=false
                         this.Image_onUpload(questionID)
                     }else if(this.inUploadOption==true){
                         console.log('time to upload!')
                         this.inUploadOption=false
                         this.Image_onUpload_Option(questionID,this.optionForEdit)
                     }
                    }
                }else{
                    this.errorMessage = "Error Getting Election: " + response.data.RequestException.Message;
                }
                
            })
            .catch(e=>{
                this.errorMessage = "Error Getting Election: " + e.message
                console.log(e)
                return e
            });
        },
        splitDates(){
            var start=this.selectedResult.dateStart
            this.editDateStart=this.formatDateForInput(start)
            this.displayDateStart =this.formatDate(start) + ' ' + this.formatTime(start)
            this.timeStart=this.formatTime(start)

            var end= this.selectedResult.dateEnd 
            this.editDateEnd=this.formatDateForInput(end)
            this.timeEnd=this.formatTime(end)
            this.displayDateEnd=this.formatDate(end) + ' ' + this.formatTime(end)
        },
        getquestionByID(questionID){
            
            var i;
            for(i=0;i<this.selectedResult.questions.length;i++){
                var question = this.selectedResult.questions[i]
                if(question.id==questionID){return question}
            }
        },
        getOptionByID(questionID,optionID){
            console.log('qid:' + questionID + ' oid:' + optionID)
            var i;
            var j;
            for(i=0;i<this.selectedResult.questions.length;i++){
                var question = this.selectedResult.questions[i]
                if(question!=undefined){
                    if(question.id==questionID){
                        
                        for(j=0;j<question.options.length;j++){
                            var option = question.options[j]
                            if(option.id==optionID){
                                return option;
                            }
                        }
                    }
                }
                
            }
        },
        togglequestion(questionID){
            
            var question = this.getquestionByID(questionID)
            if(question.tag==""){
                question.tag="Detail"
            }else if(question.tag=="Detail"){
                question.tag=""
            }
        },
        questionShowDetail(questionID){
            var question = this.getquestionByID(questionID)
            return question.tag=="Detail" || question.tag=="Edit"
        },
        questionInEdit(questionID){
            
            var question = this.getquestionByID(questionID)
            if(question!=undefined){
                
                return question.tag=="Edit"
                this.$forceUpdate();
            }
        },
        editQuestion(questionID){
            console.log('inedit qid ' + questionID)
            var question = this.getquestionByID(questionID)
            question.tag="Edit"
            console.log("inedit " + question.tag)
        },
        saveQuestion(questionID){
            console.log("insave")
            //API save
            this.saveElection()
            var question = this.getquestionByID(questionID)

            question.tag=""
        },

        updateIsActive(){
            this.showInactiveQuestions=true;
        },
        /* removeQuestion(questionID){
            var question = this.getquestionByID(questionID)
            question.isActive=false;
            this.showInactiveQuestions=true;
            //this.saveElection()
            
      
        }, */
        
        removeOption(questionID, optionID){
            var option = this.getOptionByID(questionID,optionID)
            option.isValid=false;
           // this.saveElection()

        },
        cancelEditQuestion(questionID){
            console.log("incancel" + questionID)
            var question = this.getquestionByID(questionID)
            question.tag=""
        },
        questionClass(questionID){
            var question = this.getquestionByID(questionID)
            if(!question.isActive){
                return "inner innerInactive itemDetail"
            }else if(question.tag=="Detail"){
                return "inner itemDetailOpen";
            }else{
                return "inner itemDetail";
            }
        },
        optionClass(questionID,optionID){
            var option = this.getOptionByID(questionID,optionID)
            if(!option.isValid){
                return "inactiveOption"
            }else{
                return "activeOption";
            }
        },
        questionNameText(questionID){
            var question = this.getquestionByID(questionID)
            if(question!=null){
                return question.name;
            }
            
        },
        editElection(){
            this.inEdit=true
        },
        
        cancelEditElection(){
            this.inEdit=false
            
        },
        saveElection(){
            this.setType()
            this.selectedResult.dateStart = this.editDateStart + ' ' + this.timeStart 
            this.selectedResult.dateEnd = this.editDateEnd + ' ' + this.timeEnd 
            let req = {
                election:this.selectedResult
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('saveelection',req)
            .then(response=>{

                if(response.data.success){
                    this.lookup()
                    this.inEdit=false
                }else{
                    this.errorMessage="API Error: " + response.data.RequestException.Message;
                }
                this.pleaseWait=false;
                this.selectedResult.id = response.data.id;
                console.log('saved new id ' + this.selectedResult.id)
                this.getElection(this.selectedResult.id)
                
                

                
            })
            .catch(e=>{
                this.pleaseWait=false;
                console.log('election fail ' + e)
                return e
            });
        },  
        
        
         formatDateForInput(dateString){

            var t= new Date(dateString);

            var dd = String(t.getDate()).padStart(2, '0');
            var mm = String(t.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = t.getFullYear();

            return yyyy + '-' + mm + '-' + dd
        },
        formatDateForInputToday(){

            var t= new Date();

            var dd = String(t.getDate()).padStart(2, '0');
            var mm = String(t.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = t.getFullYear();

            return yyyy + '-' + mm + '-' + dd
        },
        formatDate(dateString){
            const t = new Date(dateString);
            var dd = String(t.getDate()).padStart(2, '0');
            var mm = String(t.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yy = t.getFullYear().toString().substr(-2)


            return mm + '/' + dd + '/' + yy 
        },
        formatTime(dateString){
            const t = new Date(dateString);
            
            var hh=String(t.getHours()).padStart(2, '0');
            var nn= String(t.getMinutes()).padStart(2, '0');
            var ss=String(t.getSeconds()).padStart(2, '0');
            console.log('time ' + dateString + ' ' + hh + ':' + nn + ':' + ss)
            return hh + ':' + nn //+ ':' + ss
        },
    }
}
</script>

<style scoped>
.wait{
    font-size:x-large;
    color:rgb(238,120,45);
    padding:20px;
}
.error{
    font-size:large;
    color:red;
    padding:20px;
}
/* main */
a{
    display:inline;
}

.mainLayout{
    display:grid;
    height:80vh;
    grid-template-columns:1fr 4fr;
    grid-template-rows:1fr 3fr;
    grid-template-areas: 
    "lookup main"
    "lookup detail";
}
/*areas*/
.lookup{
    grid-area:lookup;
}
.main{
    grid-area:main;   
}
.detail{
    grid-area:detail; 
}
.scrollDiv{
    height:430px;
    overflow-x:hidden;
    overflow-y:scroll;
}
.scrollDivLookup{
    height:380px;
    overflow-x:hidden;
    overflow-y:scroll;
}
.inner{
    border-radius:10px; 
    margin:10px;
    padding:0px;
    text-align: left;
    background-color: white;
}
.innerInactive{
    background-color: lightgray;
}
.innerTitle{
    font-size:x-large;
    color:rgb(0,158,192);
}
.horizFlex{
  display:flex;
  flex-direction: row;
  
}
.vertFlex{
  display:flex;
  flex-direction: column;
  
}
.flexLeft{
    justify-content: left;
}
.linkButton{
  background-color: transparent;
  color: rgb(0,158,192);
  font-size:small;
  border:none;
  padding:0px;
  text-decoration: underline;
}
.linkbutton:hover{
    cursor:pointer;
}
.linkButtonMedium{
  font-size:medium;
  
}

/*edit*/
.optionPanel{
    border:black;
    border-style:ridge;
    border-radius: 5px;
    border-width: thin;
    margin:10px;
}
.questionEditPanel{
    grid-area:electiontitle;
}
.editText{
    height:20px;
    margin-top:10px;
    margin-left:5px;
    width:300px;
    font:inherit;
    font-size:inherit;
}
.editCombo{
    border-width: 1;
    border-color:darkgray;
    border-radius: 5px;
    font-size:inherit;
    width:250px;
    margin-top:10px;
    height:25px;
}
.editTextDesc{
    width:350px;
}
.editLabel{
    margin-left:10px;
    margin-top:10px;
    width:200px;
}
.editQuestionButton{
    background-color: rgb(0,158,192);
    border:none;
    border-radius:5px;
    margin-left:3px;
    color:white;
    height:25px;
    margin-top:10px;

}
.uploadButton{
    background-color: rgb(0,158,192);
    border:none;
    border-radius:5px;
    color:white;
    height:25px;
    margin:10px 0px 10px 0px;
    width:100px;
}
.editImage{
    height:60px;
    margin:5px;
}
.previewImage{
    width:60px;
    margin:5px;
}
.removeButton{
    margin:5px;
    text-align: right;
}
.optionTitleLabel{
    font-size:large;
    color:rgb(0,158,192);
    margin-left:25px;
}
.optionDetailLabel{
    margin-top:0px;
    margin-bottom:0px;
    margin-left:25px;
}

/*lookup*/
.lookupDiv{
    grid-area:lookup;
    height:650px;
    padding-left:10px;
    padding-right:10px;
}

.lookupText{
    border-width: 1;
    border-color:darkgray;
    border-radius: 5px;
    font-size:inherit;
    width:160px;
}

.lookupGo{
    background-color: rgb(238,120,45);
    border:none;
    border-radius:5px;
    margin-left:3px;
    color:white;
}
.lookupSelect{
  outline-color:rgb(238,120,45);
  outline-width:2px;
  border-radius: 5px;
  font-size:inherit;
  width:200px;
  margin-bottom:5px;
}

.lookupResults{
    padding:0px;
    margin-top:10px;
}
.resultButton{
    width:96%;
    margin:5px;
    background-color:rgb(196, 218, 226);
    border:none;
    border-radius:10px;
    padding:10px;
    color:rgb(0,158,192);
    font-size:medium;
}
.resultButtonSelected{
    /* color:rgb(238,120,45); */
    font-weight:bold;
    outline-style:none;
    border-color:rgb(238,120,45);
    border-width:2px;
    border-style:solid;
}
/* personcard */
.personCard{
    display:grid;
    grid-template-columns:400px auto 120px;
    grid-template-rows:auto;
    grid-template-areas: 
    "address space personaction";
}
.personPhoto{
    grid-area:photo;
}
.image{
    margin:10px;
    height:80px;
}
.image_option{
    margin:10px 10px 10px 20px;
    height:80px;
}
.personAddress{
    grid-area:address;
    display:flex;
    flex-direction: column;
    justify-content:flex-start;
    margin-left:10px;
    padding-bottom:10px;
}
.personAction{
    grid-area:personaction;
    display:flex;
    flex-direction: column;
    text-align: center;
}
.locationtitle{
    color:rgb(0,158,192);
}
.personName{
    font-size:xx-large;
    font-weight:bold;
    color:rgb(0,158,192);
    margin-bottom:5px;
    margin-top:10px;
}
.textlistdiv{
    text-align:left;
}
.textlist{
    list-style-type:none;
    padding-left:0;
    margin-right:60px;
}
.paidmain{
    color:green;
    font-size:large;
    margin-top:20px;
    margin-left:30px;
}
.unpaidmain{
    color:red;
    font-size:large;
    margin-top:20px;
    margin-left:30px;
}
.paid{
    color:green;
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.unpaid{
    color:red;
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.inactive{
    color:rgb(53, 48, 48);
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
/* election item */
.itemDetailOpen{
    display:grid;
    grid-template-columns:500px auto 10px 120px;
    grid-template-rows:1fr 1fr;
    grid-template-areas: 
    "electiontitle space paid action"
    "electiondate space paid action";
    height:140px;
}
.itemDetail{
    display:grid;
    grid-template-columns:650px auto  120px;
    grid-template-rows:1fr;
    grid-template-areas: 
    "electiontitle space  action";
}
.itemSpace{
    grid-area:space;
    text-align:center;
    display: flex;
    flex-direction: column-reverse;
}
.electionTitle{
    grid-area:electiontitle;
    margin-left:10px;
}
.electionDate{
    margin-left:10px;
}
.titleGrid{
    display:grid;
    grid-template-columns:200px auto 100px 100px;
    grid-template-rows:1fr 1fr 1fr;
    grid-template-areas: 
    "maintitle space paid action"
    "address1 phone paid action"
    "address2 email paid action";
}
.itemAction{
    grid-area:action;
    display:flex;
    flex-direction: column;
    text-align: center;
}

/* itemtitle */
.itemTitleBar{
    display:grid;
    grid-template-columns:260px  auto 140px 120px;
    grid-template-rows:auto;
    grid-template-areas: 
    "title  space inactive add";
    margin:0px 10px 0px 10px;
}
.itemTitle{
    grid-area:title;
    
}
.itemBarTitle{
    font-size:x-large;
    /* color:rgb(0,158,192); */
    color:rgb(0,158,192);
    font-weight: bold;
    margin:5px;
}
.optionEditTitle{
    font-size:large;
    /* color:rgb(0,158,192); */
    color:rgb(0,158,192);
    font-weight: bold;
    margin:10px;
}
.optionWarning{
    font-size:medium;
    color:red;
    margin-left:5px;
}
.itemBarSubTitle{
    font-size:large;
    color:rgb(0,158,192);
    /* color:rgb(0,158,192); */
    margin-top:10px;
    margin-left:30px;
}
.inactiveCheck{
    grid-area:inactive;
    margin-top:10px;
    color:rgb(0,158,192);
}
.addButton{
    grid-area:add;
    background-color:rgb(238,120,45);
   color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   width: 100px;
   height:40px;
   margin-top:5px;
   margin-right:5px;
}
.addbuttondiv{
    grid-area:add;
}
.duplicateButton{
    grid-area:add;
    background-color:rgb(238,120,45);
   color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   width: 90px;
   height:40px;
   margin-top:20px;
   margin-left:20px;
}
.emailButton{
    grid-area:add;
    background-color:rgb(238,120,45);
   color:white;

   border-radius:20px;
   border:none;
   font-size:inherit;
   width: 90px;
   height:40px;
   margin-top:20px;
   margin-left:20px;
   margin-bottom:10px;
}
.addButtonElection{
    grid-area:add;
    background-color:rgb(238,120,45);
   color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   width: 190px;
   height:40px;
   margin-top:20px;
   margin-right:20px;
}

.button{
  background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   margin:10px 10px 0px 20px;
   width: 85px;
}
button:disabled{
    background-color:lightgray;
}
.buttonPerson{
  background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   margin:10px 10px 5px 20px;
   width: 85px;
}


.innerTransparent{

    padding:0px;
    text-align: left;

}
.questionDetail{
    margin-left:10px;
    margin-top:0px;

}
.inactiveOption{
    background-color:lightgray;
    padding:10px;

}
.activeOption{
    background-color:white;
}

.picButton{
    background-color:rgb(0,158,192);
    color:white;
    border: none;
    border-radius:10px;
    width:200px;
    height:70px;
    padding:10px;
    font-size: large;
    margin:10px;
}
.picButtonDiv{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.isactive{
    font-size:large;
    margin-top:10px;
    margin-left:5px;
}
.sendEmailDiv{
    padding:10px;
    text-align: center;
    font:inherit;
}
.sendEmailField{
    margin:10px;
    font:inherit;
}
.sendEmailLabel{
    margin-top:10px;
}
.below5{
    margin-bottom:12px;
}
.voterlistitem{
    margin:10px;
    width:500px;
}
.message{
    color:red;
}
.messagepositive{
    color:green;
}
.votelistdiv{
     height:300px;
    overflow-x:hidden;
    overflow-y:scroll;
}
input:invalid {
  border-color: red;
}
</style>

